'use client'

import { Button } from '@/components/atoms/button'
import { useAuth } from '@/hooks/use-auth'
import { cn } from '@/lib/utils'
import { routes } from '@/shared/routes'
import { usePathname, useRouter } from 'next/navigation'

export function AuthMenu() {
  const pathName = usePathname()
  const { token } = useAuth()
  const router = useRouter()

  return (
    <section className="flex items-center justify-end gap-x-1 lg:gap-x-6">
      <Button
        variant="outline"
        className="rounded-md px-4 h-8 font-medium text-xs"
        onClick={() => {
          if (token) {
            router.push(routes.PLATFORM)
          } else {
            router.push(routes.AUTH_LOGIN)
          }
        }}
      >
        Login
      </Button>

      <Button
        variant="default"
        className={cn(
          'rounded-md px-4 h-8 font-medium text-xs',
          { 'bg-[#01634F]': pathName === routes.NFE },
          { 'bg-yellow-500': pathName === routes.NFCE },
          { 'bg-blue-light-600': pathName === routes.CTE },
          { 'bg-red-600': pathName === routes.MDFE },
          { 'bg-gray-blue-600': pathName === routes.NFSE },
        )}
        onClick={() => router.push(routes.AUTH_REGISTER)}
      >
        Cadastrar
      </Button>
    </section>
  )
}
